import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submit", "replace"]

  connect() {
    this.sync()
  }

  sync() {
    if (!this.hasSubmitTarget) return
    const replace = this.element.querySelector('input[name="mode"][value="replace"]')?.checked
    if (replace) {
      this.submitTarget.dataset.turboConfirm = "Isso desativa tudo que não estiver no arquivo. Continuar?"
    } else {
      delete this.submitTarget.dataset.turboConfirm
    }
  }
}
